import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography, Box } from '@mui/material'
import { useQuery, gql } from '@apollo/client'
import Loading from 'components/global/Loading'
import SitesSelection from 'packages/ui/Arborist/components/SitesSelection'


const OPERATION_FIND_ACCOUNT_SITES = gql`
    query GetAccountSitesByContact($sf_id: String!) {
        contact: findContact(sf_id: $sf_id) {
            sf_id
            accounts(site_owner: true) {
                id
                name
                nb_children
                sf_id
                is_site
                sf_parent_id
            }
        }
    }
`


export const useSites = ({contact}) => {
  const { loading, error, data } = useQuery(OPERATION_FIND_ACCOUNT_SITES, {
    variables: {
      sf_id: contact.sf_id
    }
  })
  return {
    error,
    loading,
    accounts: data?.contact.accounts || []
  }
}

const Accounts = ({ contact }) => {
  const { accounts, loading, error } = useSites({ contact })
  const {t} = useTranslation()
  const accountParentTooltip = useCallback((account) => {
    return t('auth.admin.edit.account_parent_tooltip', {firstname: contact.first_name, lastname: contact.last_name, account: account?.name})
  }, [contact, t])
  
  if (loading) {
    return <Loading inline />
  } else if (error) {
    return <Typography variant={'caption'} color={'error'}>{t('administration.card.error_fetching_roles')}</Typography>
  }

  return (
    <Box sx={{ display: 'flex', flex: 1, height: '100%', overflow: 'hidden' }}>
      <SitesSelection accounts={accounts} hasAccountParentBadge accountParentTooltip={accountParentTooltip} />
    </Box>
  )
}
export default Accounts
